import { COOKIE_KEY } from '@/lib/Constants';
import { decryptAES } from '@/lib/crypto/AES';

/** Catalog/SSR/feed guest — not a browser session. Override in env for prod. */
export const SSR_GUEST_DEVICE_ID = process.env.HZC_SSR_GUEST_DEVICE_ID || 'hzc-ssr-guest-web';

type CookieGetter = {
  get: (name: string) => { value: string } | undefined;
};

export function isSsrGuestDeviceId(deviceId: string | undefined | null): boolean {
  const id = String(deviceId || '').trim();
  return id === SSR_GUEST_DEVICE_ID || id.startsWith('hzc-ssr-');
}

export function isBotUserAgent(ua: string | null | undefined): boolean {
  if (!ua) return false;
  return /bot|crawler|spider|slurp|facebookexternalhit|preview|lighthouse|bytespider|semrush/i.test(
    ua,
  );
}

/** Native app id first, then encrypted web cookie. SSR guest id is ignored. */
export function resolveDeviceIdFromCookies(cookies: CookieGetter): string | undefined {
  const native = String(cookies.get('hzc_device_id_plain')?.value || '').trim();
  if (native && !isSsrGuestDeviceId(native)) return native;
  const decrypted = decryptAES(cookies.get(COOKIE_KEY.DEVICE_ID)?.value).trim();
  if (decrypted && !isSsrGuestDeviceId(decrypted)) return decrypted;
  return undefined;
}
